/**
 * Add-to-cart helper: POST /cart/add.js without section HTML, refresh the
 * cart drawer, then fire add analytics and open the drawer once HTML is current.
 */

/**
 * Shoplift price test: attach the test-assignment token (populated by
 * Shoplift into the page's product form) to each line item so Shoplift's
 * cart transform can reprice it. No-op when no populated input is present.
 */
function withShopliftTestProperty(body) {
  const slpt = document.querySelector('input[name="properties[_slpt]"]')?.value;
  if (!slpt || !Array.isArray(body?.items)) return body;
  body.items.forEach((item) => {
    item.properties = item.properties || {};
    if (!item.properties._slpt) item.properties._slpt = slpt;
  });
  return body;
}

async function lpPdpFastCartAdd(body) {
  const root = window.Shopify?.routes?.root || '/';
  const res = await fetch(`${root}cart/add.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(withShopliftTestProperty(body)),
  });
  const added = await res.json();
  if (!res.ok) {
    const message =
      typeof added?.description === 'string'
        ? added.description
        : typeof added?.message === 'string'
          ? added.message
          : 'Cart add failed';
    throw new Error(message);
  }

  await new Promise((resolve, reject) => {
    if (typeof window.liquidAjaxCart?.update !== 'function') {
      resolve();
      return;
    }
    window.liquidAjaxCart.update({}, {
      lastCallback: (state) => {
        if (state?.responseData?.ok) resolve();
        else reject(new Error('Cart update failed'));
      },
    });
  });

  document.dispatchEvent(
    new CustomEvent('liquid-ajax-cart:request-end', {
      detail: {
        requestState: {
          requestType: 'add',
          responseData: { ok: true, body: added },
        },
      },
    })
  );

  return added;
}

window.lpPdpFastCartAdd = lpPdpFastCartAdd;
